<template>
  <div>
    <select class="ghost-select" @input="onInput">
      <option
        v-for="(option,index) in options"
        :key="index"
        :value="option"
      >{{ option }}{{suffix}}</option>
    </select>
    {{ value }}{{suffix}}
  </div>
</template>

<script>
export default {
    props: ['value', 'options', 'suffix'],
    methods: {
        onInput(ev) {
            this.$emit('input', ev.target.value);
        }
    }
};
</script>

<style scoped>
.ghost-select {
  position: absolute;
  display: block;
  opacity: 0;
  width: 36vh;
}

option {
  overflow: hidden !important;
}
</style>